/*
 * De rem tegen dubbel klikken, los van de schermen.
 *
 * Een opslag doet tien of meer NMBRS-calls achter elkaar en duurt seconden. Wie
 * in die tijd nog een keer klikt, start hetzelfde verzoek opnieuw: op 01-10-2026
 * gaf dat drie contracten in een NMBRS-dossier (IHR-179), en "Volgende" in het
 * NAW-scherm kan zo twee adresregels geven. De echte rem hoort aan de
 * serverkant; deze voorkomt dat iemand er uberhaupt in terechtkomt.
 *
 * In de schermen stond dit al als een losse vlag met een eigen
 * opslaanMislukt(). Hier staat het patroon een keer, zodat de regel "na een
 * fout gaat de rem er weer af" te testen is. Zie tests/logic/rem.test.js.
 */

/**
 * Start een schrijfactie, tenzij dezelfde actie nog loopt.
 *
 * De vlag gaat erop voordat het verzoek vertrekt en er weer af zodra het
 * antwoord binnen is, ook als dat een fout is: anders blijft de knop na een
 * mislukte poging voorgoed grijs en kan niemand zijn correctie opslaan.
 *
 * @param {object} houder het component dat de vlag draagt
 * @param {string} vlag naam van de vlag in data(), bijvoorbeeld 'isSaving'
 * @param {function(): Promise} actie start het verzoek en geeft de promise terug
 * @param {{vasthoudenNaSucces?: boolean}} [opties]
 *        vasthoudenNaSucces: laat de rem erop staan als het verzoek lukt. Voor
 *        acties die daarna de pagina verlaten: tussen het antwoord en het
 *        verdwijnen van de pagina kan anders nog een klik vallen.
 * @returns {Promise|null} de promise van het verzoek, of null als de rem erop
 *          stond. Bij null is er niets gestart.
 */
export function metRem(houder, vlag, actie, opties){
  if(houder[vlag]) return null;
  houder[vlag] = true;

  let verzoek;
  try {
    verzoek = actie();
  } catch (fout) {
    // Ook een actie die al bij het starten klapt (een leeg contract
    // bijvoorbeeld) mag de rem niet laten staan.
    houder[vlag] = false;
    return Promise.reject(fout);
  }

  const vasthouden = Boolean(opties && opties.vasthoudenNaSucces);
  return Promise.resolve(verzoek).then(resultaat => {
    if(!vasthouden) houder[vlag] = false;
    return resultaat;
  }, fout => {
    houder[vlag] = false;
    throw fout;
  });
}
